import { ChangeEvent } from 'react';
import { Field, FieldInputProps, FieldProps, FormikProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { PaloFormSection } from '@synergy/components-palo';
import { PoolTextField, PoolTypography } from '@synergy/components';
import { fields } from '@synergy/utils';

import { SupplierSpecialOffersOverviewFormValues } from '../models/supplier-special-offers-overview-form-values';

export const SupplierSpecialOffersDetailOverviewText = () => {
    const fieldNames = fields<SupplierSpecialOffersOverviewFormValues>();

    const handleValueChange = (
        e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        max: number,
        form: FormikProps<SupplierSpecialOffersOverviewFormValues>,
        field: FieldInputProps<string>
    ) => form.setFieldValue(field.name, e.target.value.length > max ? field.value : e.target.value);

    return (
        <PaloFormSection title={<FormattedMessage id="app.contentManagement.supplierSpecialOffers.text" />}>
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                    <FormattedMessage id="app.contentManagement.supplierSpecialOffers.textParagraph" />
                </Grid>
                <Grid item={true} xs={6}>
                    <Field name={fieldNames.title}>
                        {({ field, form, meta }: FieldProps<string>) => (
                            <PoolTextField
                                {...field}
                                fullWidth={true}
                                label={<FormattedMessage id="app.contentManagement.supplierSpecialOffers.title" />}
                                value={field.value}
                                onChange={e => handleValueChange(e, 30, form, field)}
                                required={true}
                                error={!!meta.touched && !!meta.error}
                                helperText={
                                    meta.error ? (
                                        <FormattedMessage id={meta.error} />
                                    ) : (
                                        <FormattedMessage
                                            id="app.contentManagement.supplierSpecialOffers.titleCharacterCount"
                                            values={{ value: field.value?.length ?? 0 }}
                                        />
                                    )
                                }
                            />
                        )}
                    </Field>
                </Grid>
                <Grid item={true} xs={12}>
                    <Field name={fieldNames.subtitle}>
                        {({ field, form, meta }: FieldProps<string>) => (
                            <PoolTextField
                                {...field}
                                value={field.value}
                                fullWidth={true}
                                label={<FormattedMessage id="app.contentManagement.supplierSpecialOffers.subTitle" />}
                                required={true}
                                error={!!meta.touched && !!meta.error}
                                onChange={e => handleValueChange(e, 130, form, field)}
                                helperText={
                                    meta.error ? (
                                        <FormattedMessage id={meta.error} />
                                    ) : (
                                        <FormattedMessage
                                            id="app.contentManagement.supplierSpecialOffers.subTitleCharacterCount"
                                            values={{ value: field.value?.length ?? 0 }}
                                        />
                                    )
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
        </PaloFormSection>
    );
};
